module.exports = __webpack_public_path__ + "static/media/p-logo-nanshan.c31d0757.svg";